export default __webpack_public_path__ + "static/BAP_5165-Verbessert-NR_rgb_fine-4b09a34968d18be15941de23a40a0740.jpg";